import { cn } from '../../lib/utils';

export const CardItemLabel = props => {
  const { className = '', children, ...rest } = props;

  return (
    <div 
      className={cn('text-base text-secondary font-semibold', className)}
      {...rest}
    >
      {children}
    </div>
  );
};

export const CardItemContent = props => {
  const { className = '', children, ...rest } = props;

  return (
    <div 
      className={cn('text-base text-gray-800 flex flex-row gap-2', className)}
      {...rest}
    >
      {children}
    </div>
  );
};

export const CardItemValue = props => {
  const { children, ...rest } = props;

  return (
    <div {...rest}>
      {(!children || children === '' || children === null) ? '' : children}
    </div>
  );
};

export const CardItem = props => {
  const { className = '', children, ...rest } = props;

  return (
    <div 
      className={cn('flex flex-col gap-2', className)}
      {...rest}
    >
      {children}
    </div>
  );
};
